import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'

const NoneResultSearch = (props) => {
    const { messages, resetCondition, countrySelect, channelIdInput, channelIdInputValue, channelIdSubmit } = props
    return (
        <NoneResultWrap>
            <div>{messages.rank_no_result_01}</div>
            <NoneResult>
                <div>{messages.rank_no_result_02}</div>
                <OtherChoise onClick={() => resetCondition()}>{messages.rank_no_result_03}</OtherChoise>
                <div>{messages.or}</div>
                <OtherChoise onClick={() => countrySelect('', 'All')}>{messages.rank_no_result_04}</OtherChoise>
                <div>{messages.or}</div>
                <ChannelIdInput
                    onChange={channelIdInput}
                    value={channelIdInputValue}
                    onKeyPress={e => e.key === "Enter" && channelIdSubmit()}
                    type="text" placeholder={messages.rank_no_result_05}
                />
                <ChannelIdSubmit onClick={() => channelIdSubmit()}>{messages.send}</ChannelIdSubmit>
            </NoneResult>
        </NoneResultWrap>
    )
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(NoneResultSearch);
const NoneResultWrap = styled.div`
    display: flex;
    flex-direction: column;   
    align-items: center;
    margin-top: 20px;
    font-size: 24px;
    font-weight: 500;
    color: #787878;
`
const NoneResult = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;    
    font-size: 14px;
    font-weight: 300;
    color: #787878;
`
const OtherChoise = styled.div`
    font-size: 14px;
    font-weight: 300;
    text-decoration: underline;
    font-weight: 500;            
    color: #de0606;
    cursor: pointer;
    margin: 0 4px;
`
const ChannelIdInput = styled.input`
    width: 220px;
    margin-top: 4px;    
    text-align: center;
    border: .5px solid #979797;        
    ::-webkit-input-placeholder {
        font-weight: 300;    
        color: #787878;
    }
    &:focus {
        outline: none;
    }  
`
const ChannelIdSubmit = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    margin-top: 8px;    
    background-color: #de0606;
    color: #fff;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/Ranking/NoneResultSearch.js